
import {Injectable} from "@angular/core";

import { ActivatedRouteSnapshot } from "@angular/router";
import {Population, PopulationService} from "../../../../swaggerServices";
import {Observable, Subject, BehaviorSubject, of } from "rxjs";
import {map, catchError} from 'rxjs/operators';
import {initializeTaxReturn} from "../../tax-returns/get-full-tax-return";

export interface RoutePopulation {
  population?: Population;
  errorMessage?: string;
}

@Injectable()
export class PopulationRouteResolver  {
  lastClientId?: number;
  lastPopulationId?: number;
  subject: Subject<RoutePopulation> = new BehaviorSubject({});

  constructor(private populationService: PopulationService) {
  }

  resolve(route: ActivatedRouteSnapshot) {
    const clientId = Number(route.paramMap.get('clientId'));
    const populationId = Number(route.paramMap.get('populationId'));
    this.lastClientId = clientId;
    this.lastPopulationId = populationId;
    return this.resolveForIds(clientId, populationId);
  }

  resolveForIds(clientId: number, populationId: number) {
    return this.populationService.getPopulationById(populationId).pipe(
      catchError(() => of(null)),
      map((population: Population) => {
        population.assignees.forEach(assignee => (assignee.taxReturns || []).forEach(taxReturn => {
          initializeTaxReturn(taxReturn);
        }));

        const routePopulation: RoutePopulation = (population && population.clientId === clientId)  ?
          {population} : {errorMessage: `Could not find population ${populationId} for client ${clientId}`};
        if (population.id === this.lastPopulationId) {
          this.subject.next(routePopulation);
        }
        return routePopulation;
      }),);
  }

  routePopulation(): Observable<RoutePopulation> {
    return this.subject;
  }

  updatePopulation(population: Population) {
    if (!this.lastPopulationId || this.lastPopulationId === population.id) {
      this.subject.next({population});
    }
  }

  refreshPopulation(populationId: number) {
    if (this.lastPopulationId === populationId) {
      this.resolveForIds(this.lastClientId, this.lastPopulationId).subscribe();
    }
  }
}
